import { render, staticRenderFns } from "./LfTitleComponent.vue?vue&type=template&id=05455f86&scoped=true"
import script from "./LfTitleComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LfTitleComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LfTitleComponent.vue?vue&type=style&index=0&id=05455f86&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05455f86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05455f86')) {
      api.createRecord('05455f86', component.options)
    } else {
      api.reload('05455f86', component.options)
    }
    module.hot.accept("./LfTitleComponent.vue?vue&type=template&id=05455f86&scoped=true", function () {
      api.rerender('05455f86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/title/LfTitleComponent.vue"
export default component.exports